import { Button } from "@chakra-ui/react";
import EmailLink from "components/UI/ContactDetails/EmailLink";
import asyncVoidHandler from "lib/errors/asyncVoidHandler";
import { useLogout } from "lib/auth/auth";
import { useCurrentUserData } from "lib/auth/currentUserHooks";

export default function BrandStepDescription() {
  const currentUser = useCurrentUserData();
  const [logout, { loading: isLoggingOut }] = useLogout();
  const currentUserEmail = currentUser?.email;

  return (
    <>
      Your user account for{" "}
      {currentUserEmail && (
        <EmailLink email={currentUserEmail} fontWeight={600} tabIndex={-1} />
      )}{" "}
      is ready. Create your brand in SnoBase to start your workspace. Not the
      right account?{" "}
      <Button
        type="button"
        variant="link"
        size="sm"
        onClick={asyncVoidHandler(logout)}
        isLoading={isLoggingOut}
      >
        Log out.
      </Button>
    </>
  );
}
